import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  plan: string;
  quote: string;
  rating: number;
}

/** The active testimonials, in display order (Supabase `testimonials`). Used by the home pages. */
export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const { data, error } = await supabase
        .from("testimonials")
        .select("id, name, role, plan, quote, rating")
        .eq("is_active", true)
        .order("display_order", { ascending: true });

      if (error) {
        console.error("Failed to fetch testimonials:", error);
      } else if (data && data.length > 0) {
        setTestimonials(data);
      }
      setIsLoading(false);
    };

    fetchTestimonials();
  }, []);

  return { testimonials, isLoading };
};
